import template from './ContentAdvancedConfigurationView.html';
import controller from './ContentAdvancedConfigurationController';
export const ContentAdvancedConfigurationComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        onSave: '&?',
        onDelete: '&?',
    },
};
